import { useDispatch, useSelector } from 'react-redux'
import { clearSetupType, selectIsShowOption, selectSetupTypeUpdate, selectSetupUpdateId, selectSizes, setIsShowOption, setSizes } from '../../../features/setup/setupSlice'
import { useMutationData } from '../../../hooks/api/useMutationData'
import { showToast } from '../../../toastify/Toast'
import { CreateNewSize, UpdateNewSize } from '../../../features/setup/setupRequestBody'
import { handleApiError } from '../../../utils/handleApiError'
import { CloseIcon } from '../../../assets/icons/Svg'
import Input from '../../ui/Input'
import Label from '../../ui/Label'
import DropdownBtn from '../../ui/DropdownBtn'
import { statusList } from '../../../constant/default'

export default function Sizes() {

    const dispatch = useDispatch()
    const sizes = useSelector(selectSizes)
    const setupTypeUpdate = useSelector(selectSetupTypeUpdate)
    const typeId = useSelector(selectSetupUpdateId)
    const isShow = useSelector(selectIsShowOption)
    const { createSize, isLoadingCreateSize, updateSize, isLoadingUpdateSize, } = useMutationData()
    const isUpdateSize = setupTypeUpdate === 'setUpSizeUpdate'
    const headerTitle = isUpdateSize ? 'Update size' : 'Add new size'
    const isLoading = isLoadingCreateSize || isLoadingUpdateSize
    const isComplete = !sizes.size || (isUpdateSize && sizes.isActive === undefined);
    const isDisable = isComplete|| isLoading
    const sizeStatus =
        sizes.isActive === undefined
        ? "Select status"
            : sizes.isActive
        ? "Active"
            : "Inactive";
    const btnTitle = isLoading ? 
        isUpdateSize
            ? "Updating..."
            : "Creating..."
        : isUpdateSize
            ? "Save Update"
            : "Save"

    const handleSize = async () => {
        try {
            if(!sizes.size) return showToast('Size name required.','error')
            
            if(isUpdateSize) {
                if(!typeId) return showToast('Missing size id', 'error')
                if(sizes.isActive === undefined) return showToast("Size status required.", "error");
                
                const body: UpdateNewSize = {
                    size: sizes.size,
                    isActive: sizes.isActive
                }
                await updateSize({ sizeId: typeId, body}).unwrap()
                showToast('Size updated successfully', 'success')
            } else {
                const body: CreateNewSize = {
                    size: sizes.size,
                }
                await createSize(body).unwrap()
                showToast('Size created successfully', 'success')
            }
            dispatch(clearSetupType({ sizes: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))
        } catch (error) {
            handleApiError(error)
        }
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                                    {headerTitle}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => dispatch(clearSetupType({ sizes: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Size name*'}/>
                                    <Input
                                        type={'text'}
                                        value={sizes.size}
                                        onChange={(e) => dispatch(setSizes({ size: e.target.value }))}
                                        required
                                        disabled={isLoading}
                                    />
                                </div>
                                {isUpdateSize && (
                                    <div className=''>
                                        <Label label={'Status *'}/>
                                        <div className='relative inline-block h-auto w-full'>
                                            <div className='w-full h-auto'>
                                                <DropdownBtn
                                                    label={sizeStatus}
                                                    isOpen={isShow}
                                                    onClick={() => dispatch(setIsShowOption(!isShow))}
                                                    isCustomClass={true}
                                                    disabled={isLoading}
                                                    customClass={'flex w-full justify-between items-center font-medium rounded transition px-3  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                                />
                                                {isShow && (
                                                <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                                    {statusList.map((stat) => (
                                                        <li
                                                            key={stat.statusId}
                                                            onClick={() => {
                                                                dispatch(setSizes({ isActive: stat.isActive, }) );
                                                                dispatch(setIsShowOption(false));
                                                            }}
                                                            className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                                                        >
                                                            {stat.status}
                                                        </li>
                                                    ))}
                                                </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <button 
                            onClick={handleSize}
                            disabled={isDisable}
                            className={`w-full text-xs px-2 py-1.5 rounded font-medium transition-all shadow-md bg-cbColor
                                ${isComplete ? 'cursor-not-allowed bg-gray-200 border text-black' :  !isLoading ? 'text-white' : 'text-white'}
                            `}
                        >
                            {btnTitle}
                        </button> 
                    </div>
                </div>
            </div>
        </div>
    )
}
